import React, { ChangeEvent, useEffect, useState } from 'react';
import { Field, useFormikContext } from 'formik';
import { get, isEmpty } from 'lodash';

import {
  AuCallout,
  AuFormItemWrapper,
  AuControlInput,
  AuTextInput,
  AuDateInput,
  AuSelect,
  AuErrorText,
  AuInputLabel
} from 'components/DTA';
import { STATES } from 'arnConstants';

const ChangeOfNameCertificateDetails: React.FC = () => {
  const [regoYear, setRegoYear] = useState('');
  const { errors, getFieldMeta, setFieldValue } = useFormikContext();
  const declarationFieldError = get(errors, 'changeOfNameCertificateDetails.declaration');
  const numberRegexPattern = new RegExp('^-?\\d+$');
  const yearMax = 9999;

  useEffect(() => {
    const currentRegoYearValue = getFieldMeta<string>('changeOfNameCertificateDetails.registrationYear').value;
    if (currentRegoYearValue) {
      setRegoYear(currentRegoYearValue);
    }
  }, []);

  useEffect(() => {
    setFieldValue('changeOfNameCertificateDetails.registrationYear', regoYear);
  }, [regoYear]);

  const onChangeRegistrationDate = (day: string, month: string, year: string) => {
    if (year) {
      setRegoYear(year);
    }
  };

  const onChangeRegistrationYear = (event: ChangeEvent<HTMLInputElement>) => {
    if (isEmpty(event.target.value)) {
      setRegoYear(event.target.value);
      setFieldValue('changeOfNameCertificateDetails.registrationYear', '');
    }
    else {
      const currentValue = !isEmpty(event.target.value) && numberRegexPattern.test(event.target.value) ? parseInt(event.target.value) : null;
      if (currentValue && currentValue >= 1 && currentValue <= yearMax) {
        setRegoYear(event.target.value);
      }
      setFieldValue('changeOfNameCertificateDetails.registrationYear', event.target.value);
    }
  };

  return (
    <>
      <AuTextInput
        name='changeOfNameCertificateDetails.givenNames'
        label='Given names'
        as='input'
        block />
      <AuTextInput
        name='changeOfNameCertificateDetails.familyName'
        label='Family name'
        as='input'
        block />
      <AuDateInput
        name='changeOfNameCertificateDetails.dateOfBirth'
        label='Date of birth'
        hintText='For example, 31 01 1990' />
      <AuTextInput
        name='changeOfNameCertificateDetails.previousGivenNames'
        label='Previous given names'
        as='input'
        block />
      <AuTextInput
        name='changeOfNameCertificateDetails.previousFamilyName'
        label='Previous family name'
        as='input'
        block />
      <AuTextInput
        name='changeOfNameCertificateDetails.registrationNumber'
        label='Registration number'
        as='input'
        block />
      <AuSelect
        name={'changeOfNameCertificateDetails.registrationState'}
        label='Registration state'
        block
        options={[
          {
            text: 'Please select',
            value: ''
          },
          ...STATES.map((state: { name: string; code: string; }) => {
            return {
              text: state.name,
              value: state.code
            };
          })
        ]} />
      <AuDateInput
        name='changeOfNameCertificateDetails.registrationDate'
        label='Registration date'
        callback={onChangeRegistrationDate}
      />
      <AuFormItemWrapper>
        <AuInputLabel text='Registration year' htmlFor='changeOfNameCertificateDetails.registrationYear' />
        <Field
          name='changeOfNameCertificateDetails.registrationYear'>
          {() => (
            <>
              <div>
                <input
                  type='text'
                  value={regoYear}
                  onChange={onChangeRegistrationYear}
                  className={
                    'au-text-input au-text-input--block' +
                    `${getFieldMeta('changeOfNameCertificateDetails.registrationYear').error ? ' au-text-input--invalid' : ''}`
                  } />
              </div>
              {
                getFieldMeta('changeOfNameCertificateDetails.registrationYear').error &&
                <AuErrorText text={get(errors, 'changeOfNameCertificateDetails.registrationYear')} />
              }
            </>
          )}
        </Field>
      </AuFormItemWrapper>
      <AuTextInput
        name='changeOfNameCertificateDetails.certificateNumber'
        label='Certificate number'
        as='input'
        block />
      <AuDateInput
        name='changeOfNameCertificateDetails.certificateIssueDate'
        label='Certificate issue date' />
      <AuFormItemWrapper>
        <AuCallout title='' style={{ paddingTop: '0' }}>
          <AuControlInput
            name='changeOfNameCertificateDetails.declaration'
            id='checkbox-changeOfNameCertificateDetails-declaration'
            label=''
            type='checkbox'
            hintText='I confirm that I am authorised to provide the personal details
             presented and I consent to my information being checked with the document
             issuer or official record holder via third party systems for the purpose of confirming my identity'
          />
          {declarationFieldError && <AuErrorText text={declarationFieldError} />}
        </AuCallout>
      </AuFormItemWrapper>
    </>
  );
};

export default ChangeOfNameCertificateDetails;